import React, { FC } from 'react'
import StarRatings from 'react-star-ratings'

type Props = {
  rating: number
  name: string
  fillColor: string
  backdropColor?: string
  starDimension?: string
  starSpacing?: string
}

const StarRating: FC<Props> = ({ rating, name, fillColor, backdropColor, starDimension, starSpacing }) => (
  <StarRatings
    rating={rating}
    name={name}
    starRatedColor={fillColor}
    starDimension={starDimension}
    starSpacing={starSpacing}
  />
)

export default StarRating